<template>
  <div class="sr-date-picker">
    <template v-if="!getTextModel">
      <div class="start-date">
        <el-date-picker
          class="sr-date-picker"
          :type="item.timeType ? item.timeType : 'datetime'"
          :disabled="item.disabled"
          v-model="date[startname]"
          :placeholder="'请选择开始时间'"
          :picker-options="pickerOptionsStart"
          :clearable="false"
          @change="
            (val) => {
              change(val, 1);
            }
          "
          :value-format="item.format ? item.format : 'yyyy-MM-dd HH:mm:ss'"
        ></el-date-picker>
      </div>
      <div class="splite-line">~</div>
      <div class="end-date">
        <el-date-picker
          :type="item.timeType ? item.timeType : 'datetime'"
          :disabled="item.disabled"
          v-model="date[endname]"
          :placeholder="'请选择结束时间'"
          :picker-options="pickerOptionsEnd"
          :clearable="false"
          @change="
            (val) => {
              change(val, 2);
            }
          "
          default-time="23:59:59"
          :value-format="item.format ? item.format : 'yyyy-MM-dd HH:mm:ss'"
        ></el-date-picker>
      </div>
    </template>
    <div v-else>
      {{ getTextContent }}
    </div>
  </div>
</template>

<script>
export default {
  name: "SrDatePicker",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: Object | Boolean,
      default: function () {
        return {};
      },
    },
    item: {
      type: Object | Array,
      default() {
        return {};
      },
    },
    startname: {
      type: String,
      default: "startTime",
    },
    endname: {
      type: String,
      default: "endTime",
    },
    flag: {
      type: Boolean,
      default: true,
    },
    formComConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    // 是否采用文字模式
    getTextModel() {
      if (undefined === this.item.isText || '' === this.item.isText) {
        // item没有设置是否纯文本显示，判断全局的textModel
        return this.formComConfig.textModel;
      } else {
        return this.item.isText;
      }
    },
    getTextContent() {
      let val = this.date;
      let content = "";
      if (val) {
        if (val[this.startname]) {
          content += val[this.startname];
        }
        if (val[this.endname]) {
          content += " ~ " + val[this.endname];
        }
      }
      return content;
    },
  },
  watch: {
    value: {
      handler(val) {
        this.date = val;
      },
      deep: true,
    },
  },
  data() {
    return {
      date: this.value,
      pickerOptionsStart: {
        disabledDate: (time) => {
          let delay = this.date[this.endname];
          if (delay) {
            return time.getTime() >= new Date(delay).getTime();
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let delay = this.date[this.startname];
          if (delay) {
            return time.getTime() <= new Date(delay).getTime();
          }
        },
      },
    };
  },
  methods: {
    change(value, type) {
      this.$emit("change", {
        [this.startname]: this.date[this.startname],
        [this.endname]: this.date[this.endname],
      });
    },
    checkValue() {
      let flag = "";
      if (this.date[this.startname] && this.date[this.endname]) {
        flag = this.date;
      }
      this.$emit("changeModel", flag);
    },
  },
};
</script>



// WEBPACK FOOTER //
// packages/SrDatePicker/SrDatePicker.vue